<template>
  <div>
    <p>Unauthorized</p>
  </div>
</template>


<script>
import auth from '../auth'
export default {
  name: 'Unauthorized',
  created () {
    auth.logout()
  }
}

</script>
